// @ts-strict-ignore
import {
  isFormulaEntry,
  isGroupedEntry,
  isPropertyEntry,
  isSavedMetricEntry,
  QuerySuperEntry,
} from 'common/query-builder/query-entry-section/types';
import {propertyItemToSegmentation} from 'common/query-builder/query-block/properties-menu/util';
import {isListOfObjectsSegment} from 'common/query-builder/query-block/segment-menu/types';

export function getProperty(entry: QuerySuperEntry) {
  return entry.property ? propertyItemToSegmentation(entry.property, entry.property.resourceType) : null;
}

export function hasEventValue(entry: QuerySuperEntry) {
  // When adding a new row for filter/segment, the entry will be initialized to null. For other entry types,
  // a placeholder entry is used with `value` field null.
  if (isPropertyEntry(entry)) {
    return !!entry.event;
  } else if (isGroupedEntry(entry)) {
    // Grouped entries are managed by a sub- query-entry-section and always have an event.
    return true;
  } else if (isFormulaEntry(entry)) {
    return false;
  } else if (isSavedMetricEntry(entry)) {
    return false;
  }
  return !!entry.event?.value;
}

export function hasPropertyValue(entry: QuerySuperEntry) {
  const property = getProperty(entry);

  if (isListOfObjectsSegment(property) && Boolean(property.listItemGroup?.propertyName) === false) {
    return false;
  }

  return Boolean(property.propertyName || property?.customPropertyId);
}
